import ChapterProgressBar from "./ChapterProgressBar";

export default ChapterProgressBar;
